export function ArrowUpIcon({ color }: { color?: string }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.60225 1.946C5.82192 1.72633 6.17808 1.72633 6.39775 1.946L9.77275 5.321C9.99242 5.54067 9.99242 5.89683 9.77275 6.1165C9.55308 6.33617 9.19692 6.33617 8.97725 6.1165L6.5625 3.70175V9.65625C6.5625 9.96691 6.31066 10.2188 6 10.2188C5.68934 10.2188 5.4375 9.96691 5.4375 9.65625V3.70175L3.02275 6.1165C2.80308 6.33617 2.44692 6.33617 2.22725 6.1165C2.00758 5.89683 2.00758 5.54067 2.22725 5.321L5.60225 1.946Z"
        fill={color || "currentColor"}
      />
    </svg>
  );
}
